import React, { useState } from 'react';

import { Tabs, TabsList, TabsTrigger } from '@epoch-ui/components/Tabs/tabs';
import { INVITE_CATEGORIES } from 'types/invites.types';
import { useCanAccessDistrolists } from 'hooks/useCanAccessDistrolists';
import { useCanAccessCommunities, useCommunitiesLabel } from 'hooks/useCanAccessCommunities';

import { SelectedGuestsList } from '../SelectedGuestsList';

import { InviteGuestSelector } from './InviteGuestSelector';
import { InviteDistrolistSelector } from './InviteDistrolistSelector';
import { InviteCommunitySelector } from './InviteCommunitySelector';
import { InviteEmailImporter } from './InviteEmailImporter';

export const InviteSelectionStep: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<INVITE_CATEGORIES>(INVITE_CATEGORIES.INDIVIDUALS);

  const canAccessDistrolists = useCanAccessDistrolists();
  const canAccessCommunities = useCanAccessCommunities();
  const communitiesLabel = useCommunitiesLabel();

  return (
    <div className="tw-flex tw-h-full tw-min-h-64 tw-w-full tw-flex-row tw-gap-4">
      {/* Left Panel - Selection */}
      <div className="tw-flex tw-w-7/12 tw-flex-1 tw-flex-col">
        <Tabs
          value={selectedTab}
          onValueChange={(value) => setSelectedTab(value as INVITE_CATEGORIES)}
        >
          <TabsList>
            <TabsTrigger value={INVITE_CATEGORIES.INDIVIDUALS}>Individuals</TabsTrigger>
            {canAccessDistrolists && (
              <TabsTrigger value={INVITE_CATEGORIES.DISTROLISTS}>Distrolists</TabsTrigger>
            )}
            {canAccessCommunities && (
              <TabsTrigger value={INVITE_CATEGORIES.COMMUNITIES}>{communitiesLabel}</TabsTrigger>
            )}
            <TabsTrigger value={INVITE_CATEGORIES.IMPORT}>Import</TabsTrigger>
          </TabsList>
        </Tabs>

        {/* Selected tab view */}
        {selectedTab === INVITE_CATEGORIES.INDIVIDUALS && <InviteGuestSelector />}

        {selectedTab === INVITE_CATEGORIES.DISTROLISTS && canAccessDistrolists && (
          <InviteDistrolistSelector />
        )}

        {selectedTab === INVITE_CATEGORIES.COMMUNITIES && canAccessCommunities && (
          <InviteCommunitySelector />
        )}

        {selectedTab === INVITE_CATEGORIES.IMPORT && <InviteEmailImporter />}
      </div>

      {/* Right Panel - Selected Guests */}
      <div className="tw-flex tw-h-full tw-w-5/12 tw-flex-col tw-overflow-y-auto tw-rounded-2xl tw-bg-background-grey tw-p-6">
        <SelectedGuestsList />
      </div>
    </div>
  );
};
